import { facultyBreadcrumbs, facultyRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { IRole } from "@/interfaces";
import { createRoute } from "@/routes/utils";

const permission = [IRole.STAFF, IRole.SUPER_ADMIN];

const facultyRouteMetadata: IRouteMetadataObj<typeof facultyRoutesObj> = {
  list: {
    title: "facultiesManagement",
    lazy: () =>
      import("@/pages/adminPanel/facultyManagement/faculty/table/page"),
    mode: "index",
    permission,
  },
  create: {
    title: "addNewFaculty",
    lazy: () =>
      import("@/pages/adminPanel/facultyManagement/faculty/form/page"),
    mode: "create",
    permission,
  },
  edit: {
    title: "editFacultyOf",
    lazy: () =>
      import("@/pages/adminPanel/facultyManagement/faculty/form/page"),
    mode: "edit",
    permission,
  },
  view: {
    title: "viewFacultyOf",
    lazy: () =>
      import("@/pages/adminPanel/facultyManagement/faculty/view/page"),
    mode: "view",
    permission,
  },
};

export const facultyRoutes = createRoute<typeof facultyRoutesObj>(
  facultyRoutesObj,
  facultyRouteMetadata,
  facultyBreadcrumbs,
);
